/**
 * Quick Scan progress helpers — GO4 (Feb 2026).
 *
 * Levert tekstcues en early-value preview-zinnen voor de 3-stappen
 * Energy Control quickscan zonder copy in de hook of pagina te verspreiden.
 */

export const TOTAL_STEPS = 3;

/**
 * Label per stap. Maakt voortgang explicieter dan "Vraag X van 3":
 *   1 → "Stap 1 van 3 · ±30 sec"
 *   2 → "Stap 2 van 3 · bijna klaar"
 *   3 → "Laatste stap"
 */
export function stepProgressLabel(currentStep) {
  if (currentStep >= TOTAL_STEPS) return 'Laatste stap';
  if (currentStep === TOTAL_STEPS - 1) return `Stap ${currentStep} van ${TOTAL_STEPS} · bijna klaar`;
  return `Stap ${currentStep} van ${TOTAL_STEPS} · ±30 sec`;
}

/**
 * Dynamische CTA-tekst per stap. Step 3 = scherpe demo-belofte.
 */
export function stepCtaLabel(currentStep, loading) {
  if (loading) return 'Bezig…';
  if (currentStep >= TOTAL_STEPS) return 'Toon mijn persoonlijke demo';
  if (currentStep === TOTAL_STEPS - 1) return 'Bijna klaar';
  return 'Volgende stap';
}

// Mapping van het step1 doel naar een korte, eerlijke preview-zin.
// GEEN gegarandeerde besparing, GEEN besparingsbedragen, GEEN
// automatische-sturing claims. Alleen "er is een kans" framing.
const GOAL_PREVIEW = {
  use_own_solar:
    'meer eigen zonnestroom direct te gebruiken in plaats van terug te leveren',
  lower_bill:
    'uw maandelijkse stroomverbruik beter te begrijpen en bij te sturen',
  peak_management:
    'slimmer om te gaan met piekverbruik op uw aansluiting',
  salderen_2027:
    'voor te bereiden op de afbouw van de salderingsregeling in 2027',
  unknown:
    'uw persoonlijke kansen op één plek zichtbaar te maken',
};

/**
 * Eerlijke mini-preview zin direct na step 1. Wordt getoond bovenaan
 * step 2 zodat de gebruiker waardesignaal krijgt vóórdat hij/zij meer
 * vragen beantwoordt.
 *
 * Voorbeeld output:
 *   "Eerste signaal: uw situatie kan interessant zijn om meer eigen
 *    zonnestroom direct te gebruiken. Nog 2 korte stappen."
 *
 * @param {string} goal — antwoord op step 1 (gestandaardiseerde key)
 * @returns {string|null} — preview-tekst of null als goal ongeldig
 */
export function earlyValuePreview(goal) {
  if (!goal || typeof goal !== 'string') return null;
  const tail = GOAL_PREVIEW[goal] || GOAL_PREVIEW.unknown;
  return `Uw situatie kan interessant zijn om ${tail}. Nog 2 korte stappen voor uw persoonlijke scan.`;
}
